import React from 'react';
import './Vision.css';


const Vision = () => {
    return (
        <section className="our-vision text-center">
            <div className="container">
                <h2>Our vision</h2>
                <h3>To <span>transform</span> the lore ipsum<br/>
                    of  every <span>great city</span>  in the world.
                </h3>
            </div>
        </section>
    )
}

export default Vision
